import { Alert, Button, Code, Group, Modal, ScrollArea } from "@mantine/core";
import React, { useEffect, useState } from "react";

type Props = {
  toggle: (value: null) => void;
  errors: any;
};

export const DocxErrorModal: React.FC<Props> = ({ toggle, errors }) => {
  const [formattedError, setFormattedError] = useState<any>(null);

  useEffect(() => {
    if (errors != null) {
      try {
        const arr = Array.isArray(errors?.errors)
          ? errors.errors.map((error: any) => {
              const { stack, ...rest } = error ?? {};
              return rest;
            })
          : undefined;

        const _formattedError = arr != null ? { ...errors, errors: arr } : errors;

        setFormattedError(_formattedError);
      } catch (err) {
        // Fallback hvis parsing feiler
        setFormattedError(errors);
      }
    }
  }, [errors]);

  return (
    <Modal
      opened
      onClose={() => toggle(null)}
      title="FEIL I MALER. RETT FEIL OG PRØV IGJEN"
      centered
      size="lg"
      radius="lg"
    >
      <Alert color="yellow" variant="light">
        <ScrollArea.Autosize mah={360}>
          <Code block fz="xs">
            {JSON.stringify(formattedError, null, 2)}
          </Code>
        </ScrollArea.Autosize>
      </Alert>

      <Group justify="flex-end" mt="md">
        <Button onClick={() => toggle(null)}>OK</Button>
      </Group>
    </Modal>
  );
};
